// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_SET_STATE_PROPERTY,
} from './constants';

export function setStateProperty(property, value) {
  return {
    type: SIMULADOR_FINANCIERO_SET_STATE_PROPERTY,
    property: property,
    value: value
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_SET_STATE_PROPERTY:
      let aux = {...state};
      aux[action.property] = action.value;
      return aux;

    default:
      return state;
  }
}
